import { WorkflowRunGroup } from '@aero-platform/shared'
import { RunStatus } from './types'

export {
  computeSupersededIds,
  getRunConfigCaseSupersedeKey,
  getSupersedeCaseKey
} from '@aero-platform/shared'

export type MAVCase = {
  ID: string
  Name: string
  IsReference: boolean
  DataPath: string
}

export type LocalScriptCommand = {
  gmId: string
  seriesId: string
  storageAcct: string
  caseDir: string
}

export type MAVParam = {
  Name?: string
  Description?: string
  LocalStoragePath?: string
  NetworkStoragePath?: string
  Cases: MAVCase[]
}

export const getMAVCase = (
  workflowRunGroup: WorkflowRunGroup,
  isReference: boolean
): string | MAVCase => {
  if (!workflowRunGroup?.systemRunId) {
    return 'System Run ID not found for this case.'
  }
  if (!workflowRunGroup?.workflow || workflowRunGroup.workflow.length === 0) {
    return 'MAV Workflow not found for this case.'
  }

  const mavWorkflows = workflowRunGroup.workflow.filter(wkfl => {
    if (wkfl.name.includes('MAV') && wkfl.name.includes('processing')) {
      return true
    }
    return false
  })

  if (mavWorkflows.length === 0) {
    return 'MAV Workflow not found for this case.'
  }

  let mavCase: MAVCase
  const mavWorkflow = mavWorkflows[0]
  mavWorkflow.workflowTasks.forEach(task => {
    // skip if mavCases already has ID, Name, DataPath
    if (mavCase) {
      return
    }

    if (
      task.platformJob?.platformRemoteCommand &&
      task.platformJob?.platformRemoteCommand?.localScriptCommand
    ) {
      const command = task.platformJob.platformRemoteCommand.localScriptCommand
      console.log(command)
      if (command.includes('rescaleMAVProcessSubmitProxy.sh')) {
        // V#
        mavCase = {
          IsReference: isReference
        } as MAVCase
        const parts = command.split(' ')
        console.log(command)
        let index = parts.findIndex(part => part === '-c') // ID
        if (index >= 0 && parts[index + 1]) {
          mavCase.ID = parts[index + 1]
        }
        index = parts.findIndex(part => part === '-azsa') // azure storage account
        if (index >= 0 && parts[index + 1]) {
          mavCase.DataPath = parts[index + 1]
        }
        index = parts.findIndex(part => part === '-azcase') // DataPath
        if (index >= 0 && parts[index + 1]) {
          mavCase.DataPath = parts[index + 1]
        }
      } else {
        // JSON format V4+
        const commandObj: LocalScriptCommand = JSON.parse(command)
        mavCase = {
          ID: commandObj.gmId,
          Name: workflowRunGroup.runGroupCase.name,
          IsReference: isReference,
          DataPath: commandObj.caseDir
        }
      }
    }
  })

  return mavCase
}

export const isRunGroupMAVCompleted = (workflowRunGroup: WorkflowRunGroup): boolean => {
  let hasV3Workflow = false
  let v3Status = true
  let v4Status = true
  const mavWorkflows = workflowRunGroup.workflow.filter(wkflw => wkflw.name.includes('MAV'))
  mavWorkflows.forEach(wkflw => {
    wkflw.workflowTasks.forEach(task => {
      const receiverTarget = task.platformJob?.platformRemoteCommand?.receiverTarget
      if (receiverTarget === 'MAV_BASE') {
        // Check if v3 is completed or not
        hasV3Workflow = true
      }

      if (
        task.status.runStatus !== RunStatus.WARN_ON_ERROR &&
        task.status.runStatus !== RunStatus.COMPLETED
      ) {
        if (receiverTarget && receiverTarget === 'MAV_BASE') v3Status = false
        else v4Status = false
      }
    })
  })

  return mavWorkflows.length > 0 && ((hasV3Workflow && v3Status) || v4Status)
}
